import { LineItemsTable } from 'pages/requestList/components/lineItemsSection/LineItemsTable';
import { SectionContainer } from 'pages/requestList/components/SectionContainer/SectionContainer';
import { memo } from 'react';

import { getColumnDefinition } from './QBooksJournalEntryLines.config';
import { messages } from './QBooksJournalEntryLines.messages';
import { QBooksJournalEntryLinesProps } from './QBooksJournalEntryLines.types';

const QBooksJournalEntryLines = memo<QBooksJournalEntryLinesProps>((props) => {
    const { currency, lines } = props;

    if (lines.length === 0) {
        return null;
    }

    return (
        <SectionContainer title={messages.sectionTitle}>
            <LineItemsTable columnDefinitions={getColumnDefinition(currency)} lineItems={lines} />
        </SectionContainer>
    );
});

export default QBooksJournalEntryLines;
